import React, { useState } from "react";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import { imageProvider } from "../../../providers/Image.Provider";
import auth from "../../../providers/Auth.Provider";
import Image from "../../../partials/Image";

const ImageUpload = ({ onData, title, isRequired }) => {
    const [fileSelected, setFileSelected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(false);
    const [path, setPath] = useState(null);

    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();
    return (
        <div className="form-group">
            <label className="control-label">
                {title}
                {isRequired && <span className="required"> * </span>}
            </label>
            <div className="custom-file">
                <input
                    type="file"
                    multiple={false}
                    accept="image/*"
                    onChange={async (e) => {
                        setFileSelected(true);
                        setMessage(null);
                        if (e.target.files.length > 0) {
                            setLoading(true);
                            try {
                                const cb = await imageProvider.Upload(site && site.id, e.target.files[0]);
                                setLoading(false);
                                setPath(cb.path);
                                onData(cb);
                                setMessage(cb.message);
                            } catch (error) {
                                setLoading(false);
                                setMessage(error.message);
                            }
                        } else {
                            setMessage("No File Selected!");
                        }
                    }}
                    className="custom-file-input"
                    id="customFile"
                />
                <label className="custom-file-label input-height" htmlFor="customFile">
                    Choose Image
                </label>
            </div>
            {fileSelected && (
                <div className="container mt-5">
                    <div className="row justify-content-md-center">
                        <div className="col-md-6 fade-in">
                            {/* Preview */}
                            <LoadingSpinner loading={loading} bar={true} />
                            {!path && message && <AlertMessage message={message} failed={true} />}
                        </div>
                    </div>
                    {path && (
                        <>
                            <div className="row justify-content-md-center">
                                <div className="col-md-6 fade-in">
                                    <Image src={path} alt="preview" />
                                </div>
                            </div>
                            <div className="row justify-content-md-center mt-3">
                                <div className="col-md-6 fade-in">
                                    <AlertMessage message={message} failed={false} />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default ImageUpload;
